"use client";
import { motion } from "framer-motion";
import type { CSSProperties, ReactElement, ReactNode, Ref, RefObject } from "react";
import { Cscrollable } from "../Cscrollable";
import { getMarkdownBlockContainerStyle, getMarkdownBlockRootStyle, } from "../Cmarkdown/markdownBlockStyles";
import { CmarkdownvisualCanvasControls } from "./CmarkdownvisualCanvasControls";
import { CONTENT_BASE_STYLE, EXPANDED_BODY_MIN_HEIGHT, EXPANDED_CANVAS_BACKDROP_BLUR, EXPANDED_CANVAS_BACKGROUND, EXPANDED_CANVAS_MAX_HEIGHT, getExpandedCanvasChromeStyle, getExpandedCanvasDisplay, SCROLL_DIRECTION_VERTICAL, SPRING_EASE, TOP_BAR_DOT_STYLE, TOP_BAR_GROUP_STYLE, TOP_BAR_STYLE, TYPE_PILL_STYLE, VISUAL_TITLE_STYLE, } from "./CmarkdownvisualStyles";
interface CmarkdownvisualCanvasProps {
    canvasSlotRef: Ref<HTMLDivElement>;
    className?: string;
    concaved: boolean;
    containerStyle?: CSSProperties;
    contentStyle?: CSSProperties;
    controls?: ReactNode;
    hasCompact: boolean;
    isModalOpen: boolean;
    onAnimationComplete: () => void;
    onCollapse: () => void;
    onOpenModal: () => void;
    rootRef: RefObject<HTMLDivElement | null>;
    style?: CSSProperties;
    title?: string | null;
    type: string;
}
export function CmarkdownvisualCanvas({ canvasSlotRef, className, concaved, containerStyle, contentStyle, controls, hasCompact, isModalOpen, onAnimationComplete, onCollapse, onOpenModal, rootRef, style, title, type, }: CmarkdownvisualCanvasProps): ReactElement {
    return (
      <motion.div key="expanded" ref={rootRef} className={className} style={{
            ...getMarkdownBlockRootStyle(style),
            transformOrigin: "top center",
            // Hide the canvas while the modal hosts the children - keeps the
            // page layout but doesn't show a gutted, half-empty card.
            display: getExpandedCanvasDisplay({ isModalOpen }),
        }} initial={{ opacity: 0, scale: 0.97, y: 12 }} whileInView={{ opacity: 1, scale: 1, y: 0 }} viewport={{ once: true, margin: "-10% 0px" }} animate={{ opacity: 1, scale: 1 }} exit={{ opacity: 0, scale: 0.97 }} transition={{ duration: 0.32, ease: SPRING_EASE }} onAnimationComplete={onAnimationComplete}>
        <div style={getMarkdownBlockContainerStyle({
            overflow: "clip",
            backgroundImage: EXPANDED_CANVAS_BACKGROUND,
            border: "none",
            ...getExpandedCanvasChromeStyle({ concaved }),
            backdropFilter: EXPANDED_CANVAS_BACKDROP_BLUR,
            WebkitBackdropFilter: EXPANDED_CANVAS_BACKDROP_BLUR,
            maxHeight: EXPANDED_CANVAS_MAX_HEIGHT,
            display: "flex",
            flexDirection: "column",
            ...containerStyle,
        })}>
          <div style={TOP_BAR_STYLE}>
            <div style={TOP_BAR_GROUP_STYLE}>
              <span style={TOP_BAR_DOT_STYLE}/>
              <span style={TYPE_PILL_STYLE}>
                {type}
              </span>
              {title ? (<span style={VISUAL_TITLE_STYLE}>
                {title}
              </span>) : null}
            </div>
            <CmarkdownvisualCanvasControls controls={controls} hasCompact={hasCompact} onCollapse={onCollapse} onOpenModal={onOpenModal}/>
          </div>
          <Cscrollable
            dataElScope="Cmarkdownvisual/CmarkdownvisualCanvas"
            direction={SCROLL_DIRECTION_VERTICAL}
            fadeSize={0}
            verticalFadeTopSize={0}
            verticalFadeBottomSize={0}
            firstItemSpacing={0}
            style={{
            flex: 1,
            minHeight: 0,
            paddingTop: 0,
            paddingBottom: 0,
        }}>
        <div ref={canvasSlotRef} style={{
            ...CONTENT_BASE_STYLE,
            minHeight: EXPANDED_BODY_MIN_HEIGHT,
            display: "flex",
            flexDirection: "column",
            ...contentStyle,
        }}/>
          </Cscrollable>
        </div>
      </motion.div>
    );
}
